import countries from 'i18n-iso-countries';
import arLocale from 'i18n-iso-countries/langs/ar.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);
countries.registerLocale(arLocale);

export default countries;
